import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { FaFire, FaCheck } from 'react-icons/fa';

const SideBar = ({ show, setShow }) => {
  const todos = useSelector(({ todos }) => todos);

  return (
    <nav className={'sidebar ' + (show ? 'active' : '')}>
      <NavLink
        to="/inbox"
        className="sidebar__link"
        activeClassName="sidebar__link--active"
        onClick={setShow}
      >
        <FaFire className="red" />
        Inbox <span>{todos.reduce((acc, todo) => (!todo.completed ? (acc += 1) : acc), 0)}</span>
      </NavLink>
      <NavLink
        to="/completed"
        className="sidebar__link"
        activeClassName="sidebar__link--active"
        onClick={setShow}
      >
        <FaCheck className="green" />
        Completed <span>{todos.reduce((acc, todo) => (todo.completed ? (acc += 1) : acc), 0)}</span>
      </NavLink>
    </nav>
  );
};

export default SideBar;
